import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "../queryKeys";
import * as userService from "./userService";

// Bumped to -v2 so the pre-caseType payload cached under the legacy key is never served.
const GROUPS_CACHE_KEY = "mbo-groups-cache-v2";

// Cache and query keys are scoped by case type so filtered and unfiltered sets never collide.
function groupsCacheKey(caseType: string | undefined) {
  return caseType ? `${GROUPS_CACHE_KEY}-${caseType}` : GROUPS_CACHE_KEY;
}

export function useGroups(caseType?: string) {
  const cacheKey = groupsCacheKey(caseType);

  return useQuery({
    queryKey: [...queryKeys.groups, caseType ?? "all"],
    queryFn: async () => {
      const data = await userService.getGroups(caseType);
      try {
        localStorage.setItem(cacheKey, JSON.stringify(data));
      } catch {
        // localStorage full or unavailable — ignore
      }
      return data;
    },
    staleTime: 5 * 60_000,
    placeholderData: () => {
      try {
        const cached = localStorage.getItem(cacheKey);
        return cached
          ? (JSON.parse(cached) as Awaited<
              ReturnType<typeof userService.getGroups>
            >)
          : undefined;
      } catch {
        return undefined;
      }
    },
  });
}

export function useLiteras() {
  return useQuery({
    queryKey: queryKeys.lookups.literas,
    queryFn: userService.getLiteras,
    staleTime: 10 * 60_000,
  });
}

export function useFbsValues() {
  return useQuery({
    queryKey: queryKeys.lookups.fbs,
    queryFn: userService.getFbsValues,
    staleTime: 10 * 60_000,
  });
}
